<template>
  <div class="card-container">
    <div class="faq-title">Perguntas frequentes sobre Coparticipação</div>
    <br />
    <div class="hide" id="ancora-faq"></div>
    <a class="card-faq-header" v-b-toggle.collapse-1>
      <div
        class="card-faq-header-content"
        @click="
          isShowComoFuncionaCoparticipacao = !isShowComoFuncionaCoparticipacao
        "
      >
        <div class="card-faq-header-title">
          Como funciona a coparticipação? Todos os planos têm?
        </div>
        <div class="card-faq-header-icon">
          <b-icon
            icon="chevron-up"
            v-show="isShowComoFuncionaCoparticipacao"
          ></b-icon>
          <b-icon
            icon="chevron-down"
            v-show="!isShowComoFuncionaCoparticipacao"
          ></b-icon>
        </div>
      </div>
    </a>
    <b-collapse id="collapse-1" class="card-faq-texto">
      <b-card class="card-faq-inner-text">
        <p>
          A coparticipação é uma forma de melhorar o custo-benefício do seu
          plano e mantê-lo ideal para suas necessidades de utilização.
        </p>
        <p>
          Em um plano com coparticipação, você terá mensalidades reduzidas e ao
          realizar consultas e procedimentos diversos, fará o pagamento da
          coparticipação.
        </p>
        <p>
          Mas não se preocupe! Os valores e percentuais da coparticipação sempre
          são pré-definidos em contrato e têm um teto máximo que pode ser
          aplicado. Além disso, você não precisa pagar nenhum valor na hora do
          seu atendimento e a coparticipação é cobrada em um boleto separado,
          próximo da mensalidade.
        </p>
      </b-card>
    </b-collapse>
    <a class="card-faq-header" v-b-toggle.collapse-2>
      <div
        class="card-faq-header-content"
        @click="isShowCalculoCoparticipacao = !isShowCalculoCoparticipacao"
      >
        <div class="card-faq-header-title">
          Como funciona o cálculo da coparticipação?
        </div>
        <div class="card-faq-header-icon">
          <b-icon
            icon="chevron-up"
            v-show="isShowCalculoCoparticipacao"
          ></b-icon>
          <b-icon
            icon="chevron-down"
            v-show="!isShowCalculoCoparticipacao"
          ></b-icon>
        </div>
      </div>
    </a>
    <b-collapse id="collapse-2" class="card-faq-texto">
      <b-card class="card-faq-inner-text">
        <p>
          O cálculo da cobrança é feito com base no custo indicado na coluna
          “Valor”, de acordo com o percentual de coparticipação definido na
          contratação do plano, respeitando o teto máximo de coparticipação
          vigente.
        </p>
        <p>
          O valor é cobrado por unidade de procedimento, portanto, procedimentos
          realizados múltiplas vezes terão o custo multiplicado pela quantidade
          executada. Havendo alteração no valor da Tabela de Referência, o custo
          cobrado do usuário será de acordo com o valor realizado na data do
          atendimento.
        </p>
        <p>
          <strong> Exemplos: </strong>
        </p>
        <p>
          <span style="color: #00945e; font-weight: bold">
            Procedimento realizado: 41101227 - RM - COLUNA CERVICAL OU DORSAL OU
            LOMBAR
          </span>
        </p>
        <p><strong>Valor na tabela de referência:</strong> R$ 791,25*</p>
        <p><strong>Percentual de coparticipação do contrato:</strong> 50%</p>
        <p>
          <strong>Teto de coparticipação:</strong> R$190,00 (Valor apenas
          exemplificativo. Consulte o seu contrato!)
        </p>
        <p><strong>Valor de coparticipação bruto:</strong> R$ 395,62</p>
        <p>
          <strong>Valor a pagar:</strong> R$190,00 (devido ao custo relativo a
          50% do valor da Tabela de Referência ser superior ao teto).
        </p>
        <p>
          <strong>Procedimento realizado (2x):</strong> 40804054 - RX – JOELHO
        </p>
        <p>
          <strong>Valor na tabela de referência:</strong> R$ 35,16 Percentual de
          coparticipação do contrato: 50%
        </p>
        <p><strong>Valor de coparticipação bruto: </strong> R$17,58</p>
        <p>
          <strong>Valor a pagar: </strong> R$ 35,16 (Como o procedimento foi
          realizado em dois joelhos, a cobrança incide em cada exame realizado,
          ou seja, 2x).
        </p>
        <p>
          Em alguns atendimentos realizados em uma unidade de Pronto
          Atendimento, podem incidir na cobrança de um pacote serviços acrescido
          da consulta de pronto socorro. Isso ocorre quando, além da consulta,
          há administração de insumos para cuidados especiais como: soro,
          medicamentos e materiais.
        </p>
        <p>
          Quando ocorre a administração destes insumos, há também a cobrança do
          pacote de Serviços assistenciais em pronto atendimento, o qual varia
          de acordo com o seu tratamento.
        </p>
        <p>
          <strong> Importante saber: </strong>
        </p>
        <p>
          • É válido esclarecer que a formação dos preços de procedimentos
          médicos é feita com base na junção de alguns componentes, sendo eles:
        </p>
        <p>
          <span class="card-faq-texto-p">HM:</span> Honorários Médicos
          (contraprestação financeira pelo serviço do profissional, seja ele
          contratado por um hospital ou clínica médica)
        </p>
        <p>
          <span class="card-faq-texto-p">CO:</span> Custo Operacional (são os
          gastos e despesas associados à manutenção e administração de materiais
          e medicamentos utilizados pelos prestadores da rede para realização de
          determinado procedimento)
        </p>
        <p>
          <span class="card-faq-texto-p">Filme:</span> Metragem da lâmina
          utilizada para impressão de exames de imagem realizados pelos
          prestadores de imagem.
        </p>
        <p>
          O valor de coparticipação é formado pela soma destes três componentes
          <strong>(HM + CO + Filme)</strong> e limitado ao teto e percentual de
          coparticipação do contrato.
        </p>
        <p>
          • A cobrança de coparticipação em internações varia conforme a
          previsão do seu contrato. Com base na definição do Ministério da
          Saúde, a Unimed pode considerar como internação apenas o cuidado
          prestado ao paciente que ultrapasse <strong>24 horas</strong> de permanência em leito
          hospitalar.
        </p>
        <p>
          • Contratos com coparticipação equivalente a 0% (zero por cento) são
          isentos de cobrança de coparticipação.
        </p>
        <p>
          • O valor da coparticipação é faturado após o recebimento e
          processamento da cobrança enviada pelo prestador que realizou o
          atendimento.
        </p>
        <p>
          Desta forma, você pode consultar os valores a serem pagos após a conta
          ter sido devidamente processada.
        </p>
      </b-card>
    </b-collapse>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowComoFuncionaCoparticipacao: false,
      isShowCalculoCoparticipacao: false,
    };
  },
};
</script>

<style scoped>
.card-container {
  padding: 0 0 5% 0;
}

.hide {
  visibility: hidden !important;
}

.faq-title {
  color: #00945e;
  border-bottom: 1px solid #e9ecef;
  font-family: UnimedSlab-SemiBold;
  font-size: 35px;
  margin-left: 15px;
  padding-bottom: 15px;
  text-align: left;
}

.card-faq-header {
  color: #6b6e6f;
  text-decoration: none;
}

.card-faq-header-content {
  cursor: pointer;
  background: #f3f3f3 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 6px #00000029;
  border-radius: 6px;
  display: table;
  height: 85px;
  margin: 20px auto;
  opacity: 1;
  text-align: left;
}

.card-faq-header-title {
  font-family: UnimedSlab-Regular;
  display: table-cell;
  vertical-align: middle;
  padding-left: 30px;
  padding-right: 50px;
}

.card-faq-header-icon {
  display: table-cell;
  vertical-align: middle;
  width: 60px;
  margin: auto;
  transition: 0.5s transform ease;
}

.card-body {
  padding-top: 0;
  padding-left: 0;
}

.card-faq-inner-text {
  font-family: UnimedSans-Regular;
  padding: 0 28px;
}

.card-faq-texto .card {
  border: none;
  border-radius: 0;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 40px;
}

.mensagem-rodape {
  padding: 50px 0;
}

.slide-enter {
  opacity: 0;
  transform: translateY(-20px);
  transition: 0.5s all ease;
}

.slide-enter-to {
  opacity: 1;
  transform: translateY(0px);
  transition: 0.5s all ease;
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
  transition: 0.5s all ease;
}

@media (min-width: 320px) {
  .card-faq-header-content {
    width: 300px;
  }
}
@media (min-width: 480px) {
  .card-faq-header-content {
    width: 440px;
  }
}

@media (min-width: 576px) {
  .card-faq-header-content {
    width: 540px;
  }
}

@media (min-width: 700px) {
  .card-faq-header-content {
    width: 680px;
  }
}

@media (min-width: 992px) {
  .card-faq-header-content {
    width: 920px;
  }
}
</style>
